import {scope, type} from 'arktype'

import {responseData} from '@/lib/api/ResponseData'
import filteredArray from '@/utils/schema/filteredArray'

// export const Range = type({
//   start: 'number | null | undefined',
//   end: 'number | null | undefined',
// })

// export const StyledText = type({
//   text: 'string',
//   text_style: 'string',
// })

// export const MenuItemsMarkupConfig = type({
//   menu_price_config_type: 'string | null | undefined',
//   range: [Range, '|', 'null'],
//   absolute: 'number | null | undefined',
// })

// export const PriceModifier = type({
//   offset: 'number | null | undefined',
//   price_modifier_type: 'string | null | undefined',
//   fixed: 'number | null | undefined',
//   percentage: 'number | null | undefined',
//   percentage_in_bps: 'number | null | undefined',
// })

// export const RoundingConfig = type({
//   rounding_mode: 'string | null | undefined',
//   rounding_method: 'string | null | undefined',
//   rounding_tie_breaker: 'string | null | undefined',
// })

// export const MenuItemsExclusionsConfig = type({
//   menu_price_config_type: 'string',
//   range: [Range, '|', 'null'],
//   absolute: 'number | null | undefined',
// })

// export const LineOptionItemConfig = type({
//   menu_items_markup_config: MenuItemsMarkupConfig,
//   price_modifier: PriceModifier,
//   rounding_config: RoundingConfig,
//   menu_items_exclusions_config: 'null | undefined',
//   menu_items_exclusions_configs: MenuItemsExclusionsConfig.array(),
//   order_delivery_method: 'string | null | undefined',
//   line_option_level: 'number[]',
// })

// export const MenuItemsExclusionsConfigs = type({})

// export const LineOptionLevel = type({})

// export const LineItemConfig = type({
//   menu_items_markup_config: [MenuItemsMarkupConfig, '|', 'null'],
//   price_modifier: [PriceModifier, '|', 'null'],
//   rounding_config: [RoundingConfig, '|', 'null'],
//   menu_items_exclusions_config: 'null | undefined',
//   menu_items_exclusions_configs: MenuItemsExclusionsConfigs.array(),
//   order_delivery_method: 'string | null | undefined',
//   line_option_level: LineOptionLevel.array(),
// })

// export const RestaurantDmpConfig = type({
//   line_item_config: [LineItemConfig, '|', 'null'],
//   line_option_item_config: [LineOptionItemConfig, '|', 'null'],
//   service_fee_flat_when_no_dmp: 'null | undefined',
//   service_fee_percent_when_no_dmp: 'null | undefined',
//   alternate_fees: 'null | undefined',
// })

export const Stats = type({
  total_results: 'number | null | undefined | null | undefined',
  result_count: 'number | null | undefined',
  page_size: 'number | null | undefined',
  total_hits: 'number | null | undefined',
})

// export const DeliveryFee2 = type({
//   flat_cents: 'number | null | undefined',
//   percent_charge: 'number | null | undefined',
//   attribution: 'string | null | undefined | null | undefined',
// })

// export const DeliveryFee = type({
//   price: 'number | null | undefined',
//   currency: 'string | null | undefined',
// })

// export const ServiceFee = type({
//   flat_cents: 'number | null | undefined',
//   basis_points: 'number | null | undefined',
//   maximum_flat_amount: 'number | null | undefined',
//   minimum_flat_amount: 'number | null | undefined',
//   attribution: 'string | null | undefined',
//   zero: 'boolean',
//   flat: 'boolean',
//   percent: 'boolean',
// })

// export const SmallOrderFee = type({
//   flat_cents: 'number | null | undefined',
//   threshold_cents: 'number | null | undefined',
//   attribution: 'string | null | undefined',
// })

// export const ServiceTollFee = type({
//   flat_cents: 'number | null | undefined',
//   basis_points: 'number | null | undefined',
//   attribution: 'string | null | undefined',
//   zero: 'boolean',
//   flat: 'boolean',
//   percent: 'boolean',
// })

// export const Threshold = type({
//   'threshold?': 'number | null | undefined',
//   'maximum_amount_for_percentage?': 'number | null | undefined',
// })

// export const PricingFee = type({
//   'fee_name': 'string | null | undefined',
//   'type': 'string | null | undefined',
//   'operand': 'string | null | undefined',
//   'amount': 'number | null | undefined',
//   'non_adjusted_amount': 'string | null | undefined',
//   'adjustment': 'string | null | undefined',
//   'threshold?': [Threshold, '|', 'null'],
//   'potential_adjustment': 'string | null | undefined',
//   'non_adjusted_values': 'string | null | undefined',
//   'potential_adjustment_values': 'string | null | undefined',
//   'applicable_hours': 'string | null | undefined',
//   'applicable_days_of_the_week': 'string | null | undefined',
//   'attribution': 'string | null | undefined',
//   'fee_adjustment_category': 'string | null | undefined',
//   'has_campus_subscription_specific_requirements': 'boolean',
// })

// export const PickupResponse = type({
//   service_fee: ServiceFee,
//   small_order_fee: 'string | null | undefined',
//   pricing_fees: PricingFee.array(),
// })
// export const SupplementalOpenClosedContainer = type({
//   open: 'boolean',
//   open_pickup: 'boolean',
//   next_open_at: 'string | null | undefined',
//   next_open_at_pickup: 'string | null | undefined',
//   next_delivery_time: 'string | null | undefined',
//   next_pickup_time: 'string | null | undefined',
//   next_closed_at: 'string | null | undefined',
//   next_closed_at_pickup: 'string | null | undefined',
//   inundated: 'boolean',
//   soft_blackouted: 'boolean',
// })

// export const HitTags = type({
//   'sort_keys?': 'string | null | undefined',
//   'model_sort_score?': 'string | null | undefined',
//   'response_hits_mapper?': 'string | null | undefined',
//   'query_name?': 'string | null | undefined',
//   'sort_scores?': 'string | null | undefined',
// })

// export const RestaurantAggregationInfo = type({
//   'merchant_id?': 'string | null | undefined',
//   'menu_items_count?': 'number | null | undefined',
//   'menu_items_image_count?': 'number | null | undefined',
//   'menu_items_image_coverage?': 'number | null | undefined',
//   'categories_count?': 'number | null | undefined',
//   'categories_image_count?': 'number | null | undefined',
//   'categories_image_coverage?': 'number | null | undefined',
// })

// export const CurbsidePickupInstructions = type({
//   offers_curbside_pickup: 'boolean',
//   contact_phone: 'string | null | undefined',
//   curbside_instructions: 'string | null | undefined',
// })

export const Pager = type({
  total_pages: 'number | null | undefined',
  current_page: 'number | null | undefined',
})

// export const SponsoredResult = type({
//   'search_sponsored_id?': 'string | null | undefined',
//   'stats?': Stats,
//   'results?': 'string[] | null | undefined',
// })

// export const MarketContext = type({
//   market_size: 'string | null | undefined',
//   geohash: 'string | null | undefined',
//   adjusted_reasons: 'string[] | null | undefined',
// })

// export const QueryExpansion = type({})

// export const QueryExpansionContext = type({
//   original: 'string | null | undefined',
//   query_expansion: 'string[] | null | undefined',
//   type: 'string | null | undefined',
// })

// export const IntentSearchContent = type({
//   analysisType: 'string | null | undefined',
//   analysisValue: 'string | null | undefined',
//   analysisSource: 'string | null | undefined',
// })

// export const ModalOutputs = type({})

// export const DcpResponseInfo = type({
//   flow_name: 'string | null | undefined',
//   group_name: 'string | null | undefined',
//   model_outputs: ModalOutputs,
// })

// export const CacheContext = type({
//   cacheKeys: 'string[] | null | undefined',
//   restoredFromCache: 'boolean',
// })

export const Ratings = type({
  rating_count: 'number | null | undefined',
  rating_value: 'string | null | undefined',
  rating_bayesian_half_point: 'number | null | undefined',
  rating_bayesian10_point: 'number | null | undefined',
  actual_rating_value: 'number | null | undefined',
  hidden: 'boolean',
  isTooFew: 'boolean',
  too_few: 'boolean',
})

// export const PhoneNumber = type({
//   country_code: 'string | null | undefined',
//   phone_number: 'string | null | undefined',
// })

// export const AddressCountry = type({})

export const Address = type({
  address_country: 'string | null | undefined',
  address_locality: 'string | null | undefined',
  address_region: 'string | null | undefined',
  postal_code: 'string | null | undefined',
  street_address: 'string | null | undefined',
  latitude: 'string | null | undefined',
  longitude: 'string | null | undefined',
})

// export const DeliveryEstimateRange = type({
//   start_time: 'string | null | undefined',
//   end_time: 'string | null | undefined',
//   single_estimate_time: 'string | null | undefined',
//   start_time_minutes: 'number | null | undefined',
//   end_time_minutes: 'number | null | undefined',
//   single_estimate_minutes: 'number | null | undefined',
//   eta_notation: 'string | null | undefined',
// })

// export const MediaImage = type({
//   base_url: 'string | null | undefined',
//   public_id: 'string | null | undefined',
//   format: 'string | null | undefined',
//   tag: 'string | null | undefined',
//   source: 'string | null | undefined',
//   scale_mode: 'string | null | undefined',
// })

// export const ReviewData = type({
//   total_count: 'number | null | undefined',
//   valid_count: 'number | null | undefined',
//   top_review: 'null | undefined',
// })

// export const FacetedRatingList = type({
//   facet_name: 'string | null | undefined',
//   facet_type: 'string | null | undefined',
//   response_count: 'number | null | undefined',
//   positive_response_count: 'number | null | undefined',
//   positive_response_percentage: 'number | null | undefined',
//   too_few: 'boolean',
// })

// export const FacetedRatingData = type({
//   review_data: ReviewData,
//   faceted_rating_list: FacetedRatingList.array(),
// })

// export const BadgeList = type({
//   name: 'string | null | undefined',
//   display_name: 'string | null | undefined',
//   type: 'string | null | undefined',
//   badge_data: 'string | null | undefined',
//   metadata: 'null | undefined',
// })

// export const LogoHomePage = type({
//   base_url: 'string | null | undefined',
//   public_id: 'string | null | undefined',
//   format: 'string | null | undefined',
//   tag: 'string | null | undefined',
//   source: 'string | null | undefined',
//   scale_mode: 'string | null | undefined',
// })

// export const SearchHomePage = type({
//   base_url: 'string | null | undefined',
//   public_id: 'string | null | undefined',
//   format: 'string | null | undefined',
//   tag: 'string | null | undefined',
//   source: 'string | null | undefined',
//   scale_mode: 'string | null | undefined',
// })

// export const HeaderBackground = type({
//   base_url: 'string | null | undefined',
//   public_id: 'string | null | undefined',
//   format: 'string | null | undefined',
//   tag: 'string | null | undefined',
//   source: 'string | null | undefined',
//   scale_mode: 'string | null | undefined',
// })

// export const AdditionalMediaImages = type({
//   'LOGO_HOME_PAGE?': LogoHomePage,
//   'SEARCH_HOME_PAGE?': SearchHomePage,
//   'HEADER_BACKGROUND?': HeaderBackground,
// })

// export const DeliveryResponse = type({
//   delivery_fee: [DeliveryFee2, '|', 'null'],
//   service_fee: [ServiceFee, '|', 'null'],
//   small_order_fee: [SmallOrderFee, '|', 'null'],
//   service_toll_fee: [ServiceTollFee, '|', 'null'],
//   pricing_fees: [PricingFee.array(), '|', 'null'],
// })

// export const SearchDisplaySetting = type({
//   styled_text: StyledText,
//   id: 'string',
// })

// export const FeeDisplaySetting = type({
//   search_display_setting: SearchDisplaySetting,
//   menu_display_setting: 'string | null',
// })

// export const PriceResponse = type({
//   'is_subscription?': 'boolean',
//   'delivery_response?': [DeliveryResponse, '|', 'null'],
//   'pickup_response?': [PickupResponse, '|', 'null'],
//   'restaurant_dmp_config?': [RestaurantDmpConfig, '|', 'null'],
//   'fee_display_setting?': [FeeDisplaySetting, '|', 'null'],
// })

// export const EntityTags = type({})
// export const MenuItems = type({})
// export const PriceHelperText = type({
//   text: 'string | null | undefined',
//   text_style: 'string | null | undefined',
// })
// export const Availability = type({
//   is_available: 'boolean | null | undefined',
//   is_paused: 'boolean | null | undefined',
//   next_available_date: 'string | null | undefined',
//   next_unavailable_date: 'string | null | undefined',
//   start_date: 'string | null | undefined',
// })

// export const Images = type({})

// export const AvailableOffersAmount = type({
//   value: 'number | null | undefined',
//   type: 'string | null | undefined',
//   display_type: 'string | null | undefined',
//   currency: 'string | null | undefined',
//   order_minimum: 'number | null | undefined',
//   amount_maximum: 'number | null | undefined',
//   value_remaining_amount: 'number | null | undefined',
//   menu_item_id: 'string | null | undefined',
//   menu_category_id: 'string | null | undefined',
// })

// export const AvailableOffersAttributes = type({
//   'is_available?': 'boolean',
//   'is_paused?': 'boolean',
//   'next_available_date?': 'string | null | undefined',
//   'next_unavailable_date?': 'string | null | undefined',
//   'start_date?': 'string | null | undefined',
// })

// export const RestrictionMetadata = type({
//   'code_limit?': 'string | null',
//   'order_types?': 'string | null',
//   'restaurant_ids?': 'string | null',
//   'end_date?': 'string | null',
//   'start_date?': 'string | null',
//   'brands?': 'string | null',
// })

// export const Restriction = type({
//   type: 'string | null',
//   name: 'string | null',
//   restriction_metadata: RestrictionMetadata,
// })

// export const AvailableOffers = type({
//   'entitlement_type?': 'string | null | undefined',
//   'offer_type?': 'string | null | undefined',
//   'display_type?': 'string | null | undefined',
//   'title?': 'string | null | undefined',
//   'campaign_id?': 'string | null | undefined',
//   'is_perk?': 'boolean | null | undefined',
//   'description?': 'string | null | undefined',
//   'legal_text?': 'string | null | undefined',
//   'availability?': [Availability, '|', 'null'],
//   'images?': [Images, '|', 'null'],
//   'campaign_tags?': 'string[] | null | undefined',
//   'amount?': [AvailableOffersAmount, '|', 'null'],
//   'expires_at?': 'string | null | undefined',
//   'entitlement_id?': 'string | null | undefined',
//   'code_text?': 'string | null | undefined',
//   'restrictions?': [Restriction.array(), '|', 'null'],
//   'attributes?': [AvailableOffersAttributes, '|', 'null'],
// })

// export const Offer = type({
//   tag: 'string | null | undefined',
//   type: 'string | null | undefined',
//   base_url: 'string | null | undefined',
//   format: 'string | null | undefined',
//   public_id: 'string | null | undefined',
// })

// export const AvailableProgressCampaignImages = type({
//   OFFER: Offer,
// })

// export const RepresentationData = type({
//   earn_amount: 'number | null | undefined',
//   reward_article: 'string | null | undefined',
//   reward_title: 'string | null | undefined',
//   progress_item_count: 'number | null | undefined',
//   required_item_count: 'number | null | undefined',
//   required_item_plural: 'number | null | undefined',
//   required_item_singular: 'number | null | undefined',
//   progress_amount: 'number | null | undefined',
//   required_spend_amount: 'number | null | undefined',
//   progress_visit_count: 'number | null | undefined',
//   qualifying_order_spend_amount: 'number | null | undefined',
//   required_visit_count: 'number | null | undefined',
// })

// export const AvailableProgressCampaign = type({
//   'id?': 'string | null | undefined',
//   'description?': 'string | null | undefined',
//   'images?': AvailableProgressCampaignImages,
//   'title?': 'string | null | undefined',
//   'program_title?': 'string | null | undefined',
//   'representation_type?': 'string | null | undefined',
//   'representation_data?': RepresentationData,
//   'legal_text?': 'string | null | undefined',
//   'loyalty_description?': 'string | null | undefined',
//   'loyalty_progress_description?': 'string | null | undefined',
//   'end_date?': 'string | null | undefined',
//   'tags?': 'string[]',
//   'offer_type?': 'string | null | undefined',
//   'progress_percentage?': 'number | null | undefined',
// })

// export const Amount = type({
//   type: 'string | null',
//   currency: 'string | null',
//   value: 'number | null',
//   order_minimum_in_cents: 'number | null',
//   amount_maximum_in_cents: 'number | null',
//   menu_item_id: 'number | null',
//   menu_category_id: 'number | null',
// })

// export const DateAvailability = type({
//   available: 'boolean | null',
//   next_unavailable_date: 'string | null',
//   next_available_date: 'string | null',
//   start_date: 'string | null',
//   expire_date: 'string | null',
// })

// export const PersistentNudge = type({
//   nudge_text: 'string | null',
//   potential_entitlement_id: 'string | null',
// })

// export const AvailablePromoCodes = type({
//   'code_group_id?': 'string | null',
//   'code_group_legal_text?': 'string | null',
//   'code_group_public_title?': 'string | null',
//   'code_group_public_description?': 'string | null',
//   'code_group_internal_title?': 'string | null',
//   'auto_generated_description?': 'string | null',
//   'entitlement_id?': 'string | null',
//   'code_text?': 'string | null',
//   'restrictions?': [Restriction.array(), '|', 'null'],
//   'amount?': Amount,
//   'code_group_created_date?': 'number | null',
//   'date_availability?': DateAvailability,
//   'restriction_tags?': 'string[] | null',
//   'attributes?': 'string[] | null',
//   'image?': 'string | null',
//   'persistent_nudge?': PersistentNudge,
// })

export const Result = type({
  restaurant_id: 'string | null | undefined',
  merchant_id: 'string | null | undefined',
  // 'restaurant_hash': 'string | null | undefined',
  name: 'string | null | undefined',
  logo: 'string | null | undefined',
  description: 'string | null | undefined | null',
  // 'billing_comment': 'string | null | undefined',
  pickup: 'boolean',
  delivery: 'boolean',
  ratings: Ratings,
  // 'delivery_fee': DeliveryFee,
  // 'service_fee': 'number | null | undefined | null',
  // 'delivery_minimum': DeliveryFee,
  // 'menu_items': MenuItems,
  // 'curated_topic_ids?': 'string[] | null | undefined',
  // 'total_menu_items': 'number | null | undefined',
  cuisines: 'string[] | null | undefined',
  // 'phone_only': 'boolean',
  // 'phone_number': PhoneNumber,
  // 'routing_number': PhoneNumber,
  // 'coupons_available': 'boolean',
  // 'coupons_count': 'number | null | undefined',
  // 'first_coupon': 'null | undefined',
  // 'track_your_grub': 'boolean',
  // 'accepts_credit': 'boolean',
  // 'accepts_cash': 'boolean',
  address: Address,
  // 'highlighting_info': 'string[] | null | undefined',
  // 'time_zone': 'string | null | undefined',
  // 'price_rating': 'number | null | undefined',
  distance_from_location: 'string | null | undefined',
  delivery_time_estimate: 'number | null | undefined',
  delivery_time_estimate_lower_bound: 'number | null | undefined',
  // 'delivery_time_estimate_upper_bound': 'number | null | undefined',
  // 'delivery_estimate_range': [DeliveryEstimateRange, '|', 'null'],
  // 'real_time_eta': 'boolean',
  // 'pickup_time_estimate': 'number | null | undefined',
  // 'min_delivery_fee': DeliveryFee,
  // 'delivery_fee_without_discounts': DeliveryFee,
  // 'delivery_fee_percent': 'number | null | undefined',
  // 'restaurant_cdn_image_url': 'string | null | undefined',
  // 'media_image?': [MediaImage, '|', 'null'],
  // 'restaurant_tags': 'string[] | null | undefined',
  // 'custom_search_tags': 'string[] | null | undefined',
  // 'entity_tags': EntityTags,
  // 'recommended': 'boolean',
  // 'rank': 'number | null | undefined',
  // 'winning_ads_rank': 'number | null | undefined',
  // 'faceted_rating_data': FacetedRatingData,
  open: 'boolean',
  // 'next_open_at': 'string | null | undefined',
  // 'next_open_at_pickup': 'string | null | undefined',
  // 'next_delivery_time': 'string | null | undefined',
  // 'next_pickup_time': 'string | null | undefined',
  // 'next_closed_at': 'string | null | undefined',
  // 'next_closed_at_pickup': 'string | null | undefined',
  // 'inundated': 'boolean',
  // 'soft_blackouted': 'boolean',
  // 'badge_list': BadgeList.array(),
  // 'additional_media_images': AdditionalMediaImages,
  // 'available_hours': 'null | undefined',
  // 'override_hours': 'string | null | undefined',
  // 'catering': 'boolean',
  // 'percentage_ad_fee': 'number | null | undefined',
  // 'go_to': 'boolean',
  // 'popular_at_your_compstring?': 'boolean | null | undefined',
  // 'just_in_time_orders': 'boolean',
  // 'uid': 'string | null | undefined',
  // 'available_promo_codes': [AvailablePromoCodes, '|', 'null'],
  // 'available_offers?': [AvailableOffers.array(), '|', 'null'],
  // 'total_offers_count': 'number | null | undefined',
  // 'available_progress_campaigns': [AvailableProgressCampaign.array(), '|', 'null'],
  // 'chain_id': 'string | null | undefined',
  // 'chain_name': 'string | null | undefined',
  // 'brand_id': 'string | null | undefined',
  // 'brand_name': 'string | null | undefined',
  // 'sales_force_group': 'string | null | undefined',
  // 'pickup_estimate_info': 'string | null | undefined',
  // 'merchant_url_path': 'string | null | undefined',
  // 'score': 'number | null | undefined',
  // 'tie_breaking_score': 'number | null | undefined',
  // 'offers_background_color': 'string | null | undefined',
  // 'brand_color': 'string | null | undefined',
  // 'venue': 'string | null | undefined',
  // 'matching_brand_restaurants': 'string | null | undefined',
  // 'participants_max': 'string | null | undefined',
  // 'price_response': PriceResponse,
  // 'delivery_mode': 'string | null | undefined',
  // 'delivery_type': 'string | null | undefined',
  // 'restaurant_groups': 'string[] | null | undefined',
  // 'non_supplemental_delivery': 'boolean',
  // 'non_supplemental_open_closed_container': SupplementalOpenClosedContainer,
  // 'supplemental_delivery': 'boolean',
  // 'supplemental_open_closed_container': [SupplementalOpenClosedContainer, '|', 'null'],
  // 'pickup_travel_time_estimate': 'number | null | undefined',
  // 'pickup_drive_time_distance_in_miles': 'string | null | undefined',
  // 'pickup_travel_time_estimate_range': 'number | null | undefined',
  // 'pickup_offered': 'boolean',
  // 'merchant_types': 'string[] | null | undefined',
  // 'merchant_labels': 'string[] | null | undefined',
  // 'hit_tags?': HitTags,
  // 'special_instructions_disabled': 'boolean',
  // 'price_helper_text': [PriceHelperText, '|', 'null'],
  // 'restaurant_aggregation_info?': RestaurantAggregationInfo,
  // 'vendor_location_id': 'number | null | undefined',
  // 'new_restaurant': 'boolean',
  // 'curbside_pickup_instructions': CurbsidePickupInstructions,
})

export type Result = typeof Result.infer

export const RestaurantNotInPlatform = type({})

// export const RewriteContext = type({
//   analysisType: 'string | null | undefined',
//   analysisValue: 'string | null | undefined',
//   analysisSource: 'string | null | undefined',
//   exactMatch: 'boolean',
// })

export const Listing = type({
  listing_id: 'string | null | undefined',
  stats: Stats,
  pager: Pager,
  results: Result.array(),
  // sponsored_result: SponsoredResult,
  // market_context: MarketContext,
  // rewrite_context: [RewriteContext, '|', 'null'],
  // query_expansion_context: QueryExpansionContext,
  // variation_ids: 'string[] | null | undefined',
  // intent_search_context: [IntentSearchContent, '|', 'null'],
  // dcp_response_info: DcpResponseInfo,
  // suggested_searches: 'string[] | null | undefined',
  // restaurant_not_in_platform: 'boolean',
  // restaurant_not_in_platform_object: 'null | undefined',
  // cache_context: CacheContext,
})

export type Listing = typeof Listing.infer

export const RestaurantListingProps = type({
  orderMethod: 'string | null | undefined',
  locationMode: 'string | null | undefined',
  facetSet: 'string | null | undefined',
  pageSize: 'number | null | undefined',
  hideHateos: 'boolean',
  searchMetrics: 'boolean',
  queryText: 'string | null | undefined|null',
  location: 'string | null | undefined',
  preciseLocation: 'boolean',
  geohash: 'string | null | undefined',
  includeOffers: 'boolean',
  featureControl: 'string | null | undefined',
  sortSetId: 'string | null | undefined',
  sponsoredSize: 'number | null | undefined',
  countOmittingTimes: 'boolean',
  pageNum: 'number | null',
  sorts: 'string',
  facet: 'string[]',
})

export type RestaurantListingProps = typeof RestaurantListingProps.infer

export const UserAddressComponentProps = type({
  'long_name?': 'string',
  'short_name?': 'string',
  'types?': 'string[]',
})
export type UserAddressComponentProps = typeof UserAddressComponentProps.infer

export const AdddressDetail = type({
  street_number: 'string',
  route: 'string',
  locality: 'string',
  administrative_area_level_1: 'string',
  country: 'string',
  postal_code: 'string',
})

export const UserLocationProps = type({
  latitude: 'number | null',
  longitude: 'number | null',
  address: 'string | null',
  address_detail: AdddressDetail,
})
export type UserLocationProps = typeof UserLocationProps.infer

export const AddressSuggestion = type({
  address_components: UserAddressComponentProps.array(),
  adr_address: 'string',
  formatted_address: 'string',
  icon: 'string',
  icon_background_color: 'string',
  icon_mask_base_uri: 'string',
  name: 'string',
  place_id: 'string',
  reference: 'string',
  types: 'string[]',
  url: 'string',
  utc_offset: 'number',
  utc_offset_minutes: 'number',
  vicinity: 'string',
})
export type AddressSuggestion = typeof AddressSuggestion.infer

export const AddressSuggestionItem = type({
  description: 'string',
  place_id: 'string',
  types: 'string[]',
})
export type AddressSuggestionItem = typeof AddressSuggestionItem.infer

/// ----------------------------------------------------------------------------

const {Option} = scope({
  Option: {
    'id': 'string',
    'name?': 'string',
    'quantity': 'number',
    'price': 'string',
    'childOptions?': 'Option[] | undefined',
  },
}).export()

export type Option = typeof Option.infer

export const RestaurantInfo = type({
  name: 'string',
})

export type RestaurantInfo = typeof RestaurantInfo.infer

export const LineItem = type({
  'restaurantId': 'string',
  'menuCategoryId': 'string',
  'menuItemId': 'string',
  'name': 'string',
  'price': 'string',
  'quantity': 'number',
  'dinerTotal': 'string',
  'options?': Option.array(),
  'restaurantInfo?': RestaurantInfo,
})

export type LineItem = typeof LineItem.infer

export const Lines = type({
  dinerTotal: 'string',
  lineItems: LineItem.array(),
})

export type Lines = typeof Lines.infer

export const FeeItem = type({
  name: 'string',
  calculatedAmount: 'string',
})

export type FeeItem = typeof FeeItem.infer

export const Fees = type({
  total: 'string',
  delivery: 'string',
  service: 'string',
  feeItems: FeeItem.array(),
})

export type Fees = typeof Fees.infer

export const FeeTaxItem = type({
  calculatedAmount: 'string',
  feeType: 'string',
})

export type FeeTaxItem = typeof FeeTaxItem.infer

export const Taxes = type({
  total: 'string',
  delivery: 'string',
  sales: 'string',
  service: 'string',
  feeTaxItems: FeeTaxItem.array().or('undefined').optional(),
})

export type Taxes = typeof Taxes.infer

export const Tip = type({
  amount: 'string',
  type: 'string',
})

export type Tip = typeof Tip.infer

export const EstimateRange = type({
  minimum: 'number',
  maximum: 'number',
})

export type EstimateRange = typeof EstimateRange.infer

export const OrderingInfo = type({
  type: 'string',
  estimateRange: EstimateRange,
})

export type OrderingInfo = typeof OrderingInfo.infer

export const Card = type({
  brand: 'string',
  expMonth: 'number',
  expYear: 'number',
  last4: 'string',
})

export type Card = typeof Card.infer

export const Link = type({
  country: 'string',
})

export type Link = typeof Link.infer

export const PaymentInfo = type({
  paymentIntentId: 'string',
  chargeId: 'string',
  type: 'string',
  card: Card,
  link: Link,
})

export type PaymentInfo = typeof PaymentInfo.infer

export const ShippingInfo = type({
  email: 'string',
  name: 'string',
  phone: 'string',
  line1: 'string',
  city: 'string',
  state: 'string',
  postalCode: 'string',
  country: 'string',
})

export type ShippingInfo = typeof ShippingInfo.infer

export const MoreInfo = type({
  amountDiscount: 'string',
  anonymous: 'boolean',
  useWallet: 'boolean',
  amountRoundUp: 'string',
  refSrc: 'string',
  note: 'string',
  driverTip: 'string',
})

export type MoreInfo = typeof MoreInfo.infer

export const Charges = type({
  lines: Lines,
  dinerSubtotal: 'string',
  fees: Fees,
  taxes: Taxes,
  tip: Tip,
  // dinerGrandTotal: 'string',
})

export type Charges = typeof Charges.infer

export const GrubhubOrder = type({
  id: 'string',
  accountId: 'string',
  email: 'string',
  status: 'string',
  checkoutType: 'string',
  locale: 'string',
  charges: Charges,
  orderingInfo: OrderingInfo,
  // paymentInfo: PaymentInfo,
  shippingInfo: ShippingInfo,
  moreInfo: MoreInfo,
  createdAt: 'string.date.iso.parse',
  updatedAt: 'string.date.iso.parse',
  createdBy: 'string',
  updatedBy: 'string',
})

export type GrubhubOrder = typeof GrubhubOrder.infer

export const GrubhubOrderResponse = responseData(GrubhubOrder)

export const GrubhubOrders = type({
  page: 'number',
  pageSize: 'number',
  records: filteredArray(GrubhubOrder),
  total: 'number',
})

export type GrubhubOrders = typeof GrubhubOrders.infer

export const GrubhubOrdersResponse = responseData(GrubhubOrders)

export const FoodGrubhubPayment = type({
  clientSecret: 'string',
  order: GrubhubOrder,
  paymentIntentStatus: 'string',
})

export type FoodGrubhubPayment = typeof FoodGrubhubPayment.infer

export const FoodGrubhubPaymentResponse = responseData(FoodGrubhubPayment)
